import { useCallback, useState } from 'react'

import {
  CompletePostActionCompletionDocument,
  CompletePostActionCompletionMutation,
  ShowPostDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export const useCompletePostAction = () => {
  const [completed, setCompleted] = useState(false)

  const [executeMutation, { loading }] = useMutation(CompletePostActionCompletionDocument, {
    extractorFn: (data: CompletePostActionCompletionMutation) =>
      data.postsMutations.completePostsPostActionCompletion,
  })

  const completeAction = useCallback(
    async (postActionId: string) => {
      setCompleted(true)

      const result = await executeMutation({
        variables: { postActionId },
        refetchQueries: [ShowPostDocument],
        awaitRefetchQueries: true,
      })

      const handled = handleResult(result, () => undefined)

      if (!handled.success) {
        setCompleted(false)
      }

      return handled
    },
    [executeMutation]
  )

  return {
    completeAction,
    loading,
    completed,
  }
}
